module.exports = __webpack_public_path__ + "assets/img/11_793.8ded2354.jpg";